import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./components/Home";
import MedicareLanding from "./components/MedicareLanding";
import BusinessCard from "./components/BusinessCard";
import MedicalIntakeForm from "./components/MedicalIntakeForm";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/medicare" element={<MedicareLanding />} />
          <Route path="/adeen" element={<BusinessCard />} />
          <Route path="/intake" element={<MedicalIntakeForm />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
